import { useContext } from 'react';
import ChallengeContext from '@/components/ChallengePortfolio/NormalView/Challenge/ChallengeView/ChallengeContext';
import TaskContext from '@/components/ChallengePortfolio/NormalView/Task/TaskView/TaskContext';

const useRubricsPortfolioApiEndpoint = (): string => {
  const [challenge] = useContext(ChallengeContext);
  const [task] = useContext(TaskContext);

  if (challenge === null) {
    return 'portfolio';
  }

  if (task === null) {
    return `challenge-portfolio/challenges/${challenge.id}/rubrics-portfolio`;
  }

  return `challenge-portfolio/tasks/${task.id}/rubrics-portfolio`;
};

export default useRubricsPortfolioApiEndpoint;
